import axios from 'axios'

export default {
    get: () => axios.get('warehouses'),
    store: (data) => axios.post('warehouses/store', data),
    update: (data) => axios.post('warehouses/update', data),
    delete: (id) => axios.post('warehouses/delete', id)
}